import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-evaluation-skip-test',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './evaluation-skip-test.component.html',
  styleUrls: ['./evaluation-skip-test.component.scss']
})
export class EvaluationSkipTestComponent implements OnInit {

  constructor(
    private modal: NgbActiveModal,
    private langSrcSrv: LangSrcService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  close() {
    this.modal.close();
  }

  async quit() {
    await this.router.navigate([
      '/',
      this.langSrcSrv.current.shortCode,
      'learning',
      'dashboard'
    ]);
    this.close();
  }

}
